import { render } from "./Marketplace.vue?vue&type=template&id=3bc89724&scoped=true"
import script from "./Marketplace.vue?vue&type=script&lang=js"
export * from "./Marketplace.vue?vue&type=script&lang=js"

import "./Marketplace.vue?vue&type=style&index=0&id=3bc89724&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc89724"]])

export default __exports__